import { ApolloProvider } from "@apollo/client";
import React from "react";
import { createRoot } from "react-dom/client";
import { ApiInterceptors } from "./services/api/api";
import App from "/@/App";
import { AuthProvider } from "./shared/contexts/AuthContext";
import { MantineEmotionProvider } from "@mantine/emotion";
import { IpcContextProvider } from "/@/shared/contexts/IpcContext";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";
import { setFeatureFlagEvaluationProperties } from "@jasper/shared";
import client from "/@/apolloClient";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/carousel/styles.css";
import i18n from "./i18n";
import { MantineJasperThemeProvider } from "@jasper/forms";
import { seedRemoteUploadSession } from "./shared/utils/remoteUploadSession";
import { ProductTranslationProvider } from "@jasper/translations";

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: "identified_only",
  loaded: posthog => {
    posthog.register({
      webapp_version: import.meta.env.VITE_APP_VERSION,
      environment: import.meta.env.MODE,
      host: window.location.host,
    });
    setFeatureFlagEvaluationProperties(posthog);
  },
});

seedRemoteUploadSession();

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <AuthProvider>
        <IpcContextProvider>
          <MantineJasperThemeProvider>
            <MantineEmotionProvider>
              <Notifications
                position="bottom-center"
                pauseResetOnHover="notification"
              />
              <ApiInterceptors>
                <ModalsProvider>
                  <ApolloProvider client={client}>
                    <ProductTranslationProvider i18n={i18n}>
                      <App />
                    </ProductTranslationProvider>
                  </ApolloProvider>
                </ModalsProvider>
              </ApiInterceptors>
            </MantineEmotionProvider>
          </MantineJasperThemeProvider>
        </IpcContextProvider>
      </AuthProvider>
    </PostHogProvider>
  </React.StrictMode>
);
